export default __webpack_public_path__ + "static/media/welcome-dashboard-leader.e50c6faa.png";